/**
 * Created by coolguy on 2017/7/5.
 */
import React, {useEffect, useState} from 'react';
import {Modal, message,Row, Tabs} from 'antd';
import Info from '../Detail/Info';
import {findMatterType, MatterType} from './List';
import moment from 'moment';
import {parseJSON} from '../../util/index';
import './List.scss';

import {Watermarks, ALIGN_MAP} from '../FileViewerV2/page/tree/index';

export default (props)=>{
  const {data = {}, onClose} = props;
  const {id} = data;

  const [name, setName] = useState(data.title);
  const [type, setType] = useState(data.type);
  const [cover, setCover] = useState(data.cover_img);
  const [orderId, setOrderId] = useState(data.order_id);
  const [galleryId, setGalleryId] = useState(data.gallery_id);
  const [beginTime, setBeginTime] = useState(null);
  const [endTime, setEndTime] = useState(null);
  const [watermarkHorizontal, setWatermarkHorizontal] = useState(data.horizonal_watermark);
  const [watermarkVertical, setWatermarkVertical] = useState(data.vertical_watermark);

  useEffect(()=>{
    setBeginTime(moment(data.begin_at).isValid() ? moment(data.begin_at) : null);
    setEndTime(moment(data.end_at).isValid() ? moment(data.end_at) : null);
  }, [id || 0]);

  const onSubmit = ()=>{
    if(!name) {
      message.error('视频名称为必填项');
      return;
    }
    if(!cover) {
      message.error('视频封面为必填项');
      return;
    }
    if(!beginTime || !moment(beginTime).isValid()) {
      message.error('直播开始时间为必填项');
      return;
    }
    if(!endTime || !moment(endTime).isValid()) {
      message.error('直播结束时间为必填项');
      return;
    }
    if(moment(beginTime).isAfter(moment(endTime))) {
      message.error('直播结束时间必须大于开始时间');
      return;
    }

    if(props.onSubmit) {
      let promise = props.onSubmit({
        id,
        title:name,
        cover_img:cover,
        order_id:orderId,
        gallery_id:galleryId,
        horizonal_watermark:watermarkHorizontal,
        vertical_watermark:watermarkVertical,
        status:(data && data.status) ? data.status : 'config',
        begin_at:beginTime.format('YYYY-MM-DD HH:mm:ss'),
        end_at:endTime.format('YYYY-MM-DD HH:mm:ss'),
        medium_id:data.medium_id
      });

      if(promise instanceof Promise) {
        promise.then(onClose);
      }else {
        onClose();
      }
    }
  };

  return <Modal visible={!!data} key={id} width={700} wrapClassName="video-add-modal"
    title={(!!id ? '编辑' : '新建') + '直播视频'}
    onCancel={onClose}
    onOk={onSubmit}
    centered
  >
    <Info type="text" required label="视频名称" value={name} onChange={setName} />
    <Info type="datetime" required label="直播开始时间" showSecond={true} value={beginTime} onChange={(e)=>{
      setBeginTime(e);
      setEndTime(moment(e).add('12', 'h'));
    }} />
    <Info type="datetime" required label="直播结束时间" isText value={<span style={{fontSize:12,marginLeft:12}}>{moment(endTime).format('YYYY-MM-DD HH:mm')}</span>} />
    <Info type="upload" required label="视频封面" value={cover} onChange={setCover} tooltip="建议上传：750x420 大小的图片" />
  </Modal>
};



// WEBPACK FOOTER //
// ./src/components/Video/AddVideo.js